module.exports = __webpack_public_path__ + "static/img/Sam-Froling.7f95c74.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Sam-Froling.jpg
// module id = ZQo1
// module chunks = 1